import {
  TpvDashboardSummary,
  TpvDonutChart,
  TpvMonthlyPoint,
  TpvSalesMetric,
} from '@app/domain/models/tpv/tpv-dashboard-summary.model';
import {
  TpvDashboardDto,
  TpvMonthlySeriesDto,
  TpvPaymentSliceDto,
  TpvSalesMetricDto,
} from '@app/data/dtos/tpv/dashboard-summary.dto';

function mapSalesMetric(dto: TpvSalesMetricDto | undefined): TpvSalesMetric {
  return {
    count: Number(dto?.count ?? 0),
    amount: Number(dto?.amount ?? 0),
  };
}

/** Una porción de dona toma `count` como valor y conserva el porcentaje del backend. */
function mapPaymentDonut(slices: TpvPaymentSliceDto[] | undefined): TpvDonutChart {
  return {
    slices: (slices ?? []).map((s) => ({
      label: s.label ?? '',
      value: Number(s.count ?? 0),
      percentage: Number(s.percentage ?? 0),
    })),
  };
}

function mapMonthlyAmount(series: TpvMonthlySeriesDto[] | undefined): TpvMonthlyPoint[] {
  return (series ?? []).map((p) => ({ month: p.period ?? '', value: Number(p.amount ?? 0) }));
}

function mapMonthlyTransactions(series: TpvMonthlySeriesDto[] | undefined): TpvMonthlyPoint[] {
  return (series ?? []).map((p) => ({ month: p.period ?? '', value: Number(p.count ?? 0) }));
}

/** Convierte el `extra_data` del backend en el modelo de dominio del dashboard. */
export function mapTpvDashboardSummary(dto: TpvDashboardDto): TpvDashboardSummary {
  const summary = dto.summary;
  return {
    totalSales: mapSalesMetric(summary?.ventas_totales),
    cancellations: mapSalesMetric(summary?.cancelaciones),
    netSales: mapSalesMetric(summary?.ventas_netas),
    enabledMerchants: Number(summary?.comercios_habilitados ?? 0),
    activeMerchants: Number(summary?.comercios_activos ?? 0),
    avgTransactionsPerMerchant: Number(summary?.trx_promedio_por_comercio ?? 0),
    averageAmount: Number(summary?.monto_promedio ?? 0),
    transactionsTotal: Number(summary?.transacciones_totales ?? 0),
    paymentByMethod: mapPaymentDonut(dto.payment_methods?.by_method),
    paymentByBrand: mapPaymentDonut(dto.payment_methods?.by_brand),
    monthlyAmount: mapMonthlyAmount(dto.monthly_series),
    monthlyTransactions: mapMonthlyTransactions(dto.monthly_series),
  };
}
